import { render, staticRenderFns } from "./CommitmentComponent.vue?vue&type=template&id=658bea0c&scoped=true&"
import script from "./CommitmentComponent.vue?vue&type=script&lang=js&"
export * from "./CommitmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentComponent.vue?vue&type=style&index=0&id=658bea0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658bea0c",
  null
  
)

export default component.exports